<template>
  <Layout>
    <PageHeader :title="title" :items="items" />


    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">

            <h4 class="card-title">Data Table</h4>
            <button v-b-modal.modal-user class="btn btn-success" @click="resetModal"><i class="bx bxs-plus-square mr-1"></i> Add Institusi</button>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select v-model="perPage" size="sm" :options="pageOptions"></b-form-select>&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                        v-model.lazy="searchText"
                        type="search"
                        placeholder="Search Code..."
                        class="form-control form-control-sm ml-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <vue-good-table
                  mode="remote"
                  :pagination-options="{
                    enabled: false,
                    mode: 'pages',
                    perPage: perPage,
                    position: 'bottom',
                    perPageDropdown: [5, 10],
                    dropdownAllowAll: false,
                    nextLabel: 'next',
                    prevLabel: 'prev',
                    rowsPerPageLabel: 'Rows per page',
                    ofLabel: 'of',
                    pageLabel: 'page', // for 'pages' mode
                    allLabel: 'All',
                  }"
                  :totalRows="totalRows"
                  :rows="institutionData"
                  :columns="columns"
                  :sort-options="{
                    enabled: false,
                    initialSortBy: {field: 'id', type: 'desc'}
                  }"
              >
                <template slot="table-row" slot-scope="props">
                  <div v-if="props.column.field == 'btn'">
                    <b-button pill size="sm" @click="setModalInstitusi(props.row)" v-b-modal.modal-user>Edit</b-button>
                    <b-button pill variant="danger" size="sm" @click="deleteInstitusi(props.row)">Delete</b-button>
                  </div>
                  <div v-else-if="props.column.field == 'partner'">
                    {{ props.row.partner ? props.row.partner.name : '' }}
                  </div>
                </template>
              </vue-good-table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>

            <b-modal id="modal-user" :title="modalTitle" button-size="sm">
              <label>Nama:</label>
              <b-form-input v-model="institutionPayload.name"></b-form-input>
              <div v-if="mode !== 'edit'">
                <label>Password:</label>
                <b-form-input v-model="institutionPayload.password"></b-form-input>
              </div>
              <label>Nomor Sekolah:</label>
              <b-form-input v-model="institutionPayload.school_number"></b-form-input>
              <label>Jenjang</label>
              <b-form-checkbox-group
                  id="checkbox-group-jenjang"
                  v-model="institutionPayload.jenjang"
                  :options="jenjang_options"
                  name="jenjang"
              ></b-form-checkbox-group>
              <label>Rombongan Kelas:</label>
              <b-form-input v-model="institutionPayload.classroom_group"></b-form-input>
              <label>Jumlah Kelas:</label>
              <b-form-input v-model="institutionPayload.number_of_classroom"></b-form-input>
              <label>Description</label>
              <b-form-textarea v-model="institutionPayload.description"></b-form-textarea>
              <label>Alamat</label>
              <b-form-textarea v-model="institutionPayload.address"></b-form-textarea>
              <template #modal-footer="{ cancel, ok }">
                <b-button size="sm" @click="cancel">
                  Close
                </b-button>
                <b-button v-if="mode === 'insert'" variant="primary" :disabled="loadingUpdate" size="sm" @click="insertInstitusi">
                  <div v-if="loadingUpdate">
                    <b-spinner label="Loading..."></b-spinner>
                  </div>
                  <div v-else>
                    Simpan
                  </div>
                </b-button>
                <b-button v-else variant="primary" :disabled="loadingUpdate" size="sm" @click="updateInstitusi">
                  <div v-if="loadingUpdate">
                    <b-spinner label="Loading..."></b-spinner>
                  </div>
                  <div v-else>
                    Simpan
                  </div>
                </b-button>
              </template>
            </b-modal>

          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "@/router/layouts/main";
import PageHeader from "@/components/page-header";
import axios from 'axios';
import Swal from "sweetalert2";
import {multiselectMixin, Multiselect} from 'vue-multiselect'

export default {
  name: "index",
  components: { Layout, PageHeader, Multiselect },
  data() {
    return {
      title: "Institusi",
      items: [
        {
          text: "Tables",
          href: "/"
        },
        {
          text: "Institusi",
          active: true
        }
      ],
      institutionPayload: {},
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      institutionData: [],
      columns: [
        { field: "id", label: "ID" },
        { field: "code", label: "Code" },
        { field: "name", label: "Name" },
        { field: "btn", label: "Action" }
      ],
      modalTitle: "Tambah Institusi",
      searchText: "",
      mode: "",
      loadingUpdate: false,
      institutionChecked: false,
      jenjang_options: [
        { text: 'TK', value: '0' },
        { text: 'SD', value: '1' },
        { text: 'SMP', value: '2' },
        { text: 'SMA', value: '3' }
      ]
    }
  },
  methods: {
    fetchInstitusiData() {
      let params = queryString.stringify({
        ...{
          name: null,
          sort: '-id',
        }
        , ...this.getArguments}
      )
      this.httpCallInstitusiData(params)
    },
    updateInstitusi() {
      axios.put("/api/institution/"+this.institutionPayload.id, this.institutionPayload).then(resp => {
        const { data } = resp.data
        Swal.fire('Sukses')
        this.$bvModal.hide('modal-user')
        this.fetchInstitusiData()
        this.loadingUpdate = false
      });
    },
    httpCallInstitusiData(params) {
      axios.get("/api/institution?"+params)
          .then(resp => {
            const { data, total } = resp.data
            this.totalRows = total
            this.institutionData = data
            this.isFetched = true
          });
    },
    resetModal() {
      this.mode = 'insert'
      this.institutionPayload = {}
      this.modalTitle = 'Tambah Institusi'
    },
    insertInstitusi() {
      this.loadingUpdate = true
      axios.post("/api/institution", this.institutionPayload).then(resp => {
        const { message } = resp.data
        if (message !== 'success') {
          Swal.fire({
            icon: 'error',
            title: '',
            text: message,
          })
        } else {
          Swal.fire('Sukses')
          this.$bvModal.hide('modal-user')
          this.fetchInstitusiData()
        }
        this.loadingUpdate = false
      });
    },

    setModalInstitusi(institution) {
      this.mode = 'edit'
      this.institutionPayload = Object.assign({}, institution)
      this.modalTitle = 'Edit Institusi'
    },
    deleteInstitusi(rowData) {
      Swal.fire({
        title: "Yakin, hapus data ini",
        text: name,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Iya, hapus!"
      }).then(result => {
        if (result.value) {
          axios.delete("/api/institution/"+rowData.id).then(resp => {
            const { data } = resp.data
            Swal.fire('Sukses')
            this.fetchInstitusiData()
          });
        }
      });
    },
  },
  mounted() {
    this.fetchInstitusiData()
  }
}
</script>

<style scoped>

</style>